<template>
    <y-rogue-wrapper
        v-if="rogue.show"
        :name="rogue.slug"
        :type="rogue.type"
        v-bind="rogue.props"
        v-on="rogue.listeners"
    />
</template>

<script>
    import PageMixin from '@nodes/mixins/Page';

    export default {
        name: 'LoginPage',

        components: {},

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle: this.$t('auth.login.title', [this.$settings('site_title.site_title')]),

                rogue: {
                    name : 'Auth',
                    slug : 'auth',
                    type : 'modern',
                    show : true,
                    props: {
                        step      : 'login',
                        img       : this.$settings('content.auth-image.link'),
                        logo      : this.$settings('site_logos.main.link'),
                        logoAlt   : this.$settings('site_title.site_title'),
                        authTitle : this.$t('auth.title', [this.$settings('site_title.site_title')]),
                        authDesc  : this.$t('auth.description'),
                        contactTel: this.get(this.$settings('contact_details'), `elements.0.fixed_tel.${this.$i18n.locale}`)
                            ? this.get(this.$settings('contact_details'), `elements.0.fixed_tel.${this.$i18n.locale}.0`)
                            : this.get(this.$settings('contact_details'), 'elements.0.fixed_tel.fa.0'),
                        formTitle          : this.$t('auth.login.title', [this.$settings('site_title.site_title')]),
                        formDescription    : this.$t('auth.login.description.text'),
                        formDescriptionLink: {
                            title: this.$t('auth.login.description.link'),
                            route: { name: 'auth-register' },
                        },
                        formFooter      : this.$settings('copy_right.copy_right'),
                        quarkinoBranding: true,
                    },
                },
            };
        },

        methods: {},

    };
</script>
